import { createContext, useContext } from "react";

export const LangCtx = createContext({ lang: "en", setLang: () => {} });
export const useLang = () => useContext(LangCtx);

export const TA = {
  marquee: ["2000 முதல்", "பேப்பர் வாழை இலை", "உலகளவில் ஏற்றுமதி", "சூழல் நட்பு", "CFTRI சோதனை", "100% மறுசுழற்சி", "சிவகாசி, இந்தியா"],

  chapters: [
    {
      title: "சிவகாசியில் வேரூன்றியது",
      body: "2000-ஆம் ஆண்டு — அச்சு மற்றும் பேக்கேஜிங்கின் சரித்திர தலைநகரான சிவகாசியில் — JJJ Industries ஒரு எளிய யோசனையுடன் தொடங்கியது: வாழை இலையை காகிதத்தில் மறுஉருவாக்கம் செய்தல். நிர்வாக இயக்குநர் திரு. D. ஜெபஸ்டின் அவர்களின் வழிகாட்டுதலில், Lovely Foodpacks விடுதலை மற்றும் கேட்டரர்களுக்கு இயற்கை இலையின் குறைபாடுகள் இன்றி இலை உணவு பாரம்பரியத்தை வழங்கியது.",
    },
    {
      title: "பேப்பர் வாழை இலை ஏன்",
      body: "நூற்றாண்டுகளாக வாழை இலை தெற்காசியாவின் தாய்த் தட்டு — இயற்கை, மணம் மிக்க, மங்கலகரமானது. ஆனால் இயற்கை இலைகள் வாடும், கிழியும். எங்கள் பேப்பர் வாழை இலை அந்த அனுபவத்தை — நிறம், பரப்பு, சடங்கு — பாதுகாக்கிறது; உணவு பாதுகாப்புடன், வருடம் முழுவதும் கிடைக்கும்.",
    },
    {
      title: "ஆறு மாநிலங்களில் வலிமை",
      body: "26-ஆம் ஆண்டில் அடியெடுத்து வைக்கும் Lovely Leafs — தமிழ்நாடு, கேரளா, கர்நாடகா, மகாராஷ்டிரா, ஆந்திரா மற்றும் மத்திய பிரதேசம் உட்பட ஆறு மாநிலங்களில் டீலர்கள், விநியோகஸ்தர்கள், மொத்த விற்பனையாளர்கள் மற்றும் ஹோட்டல் & கேட்டரிங் துறையினரின் நம்பிக்கையைப் பெற்றுள்ளது.",
    },
    {
      title: "சிவகாசியிலிருந்து உலகிற்கு",
      body: "எங்கள் ஏற்றுமதி வழிகள் UAE, மொரிஷியஸ், மலேசியா, சிங்கப்பூர் மற்றும் பப்புவா நியூ கினியா இறக்குமதியாளர்களை சேவை செய்கின்றன — இந்திய சூழல் நட்பு பேக்கேஜிங்கை உலகம் முழுவதும் உணவகங்களுக்கு கொண்டு செல்கிறது.",
    },
  ],

  process: [
    { title: "மூலப்பொருள்", body: "உணவு தர காகிதம் & போர்டு — பாதுகாப்பான, நிலையான இலையின் அடித்தளம்." },
    { title: "அச்சிடல்", body: "துல்லிய அச்சு இலை-பச்சை நிறத்தையும் தனிப்பயன் பிராண்டிங்கையும் தருகிறது." },
    { title: "லேமினேஷன் & வெட்டுதல்", body: "ஈரப்பதம் தடுக்கும் லேமினேஷன் மற்றும் டை-கட்டிங் ஒவ்வொரு தாளையும் சரியான அளவில் வடிவமைக்கிறது." },
    { title: "தர சரிபார்ப்பு", body: "ஒவ்வொரு தொகுதியும் CFTRI சோதனை, உணவு பாதுகாப்பு தரங்களுக்கு எதிராக ஆய்வு செய்யப்படுகிறது." },
    { title: "பேக்கிங் & அனுப்புதல்", body: "எண்ணி, கட்டி, பெட்டியில் — ஒரு பாக்கெட்டில் 100 தாள்கள் — இந்தியா முழுவதும் மற்றும் உலகிற்கும் அனுப்பப்படுகிறது." },
  ],

  useCases: [
    { title: "ஹோட்டல் துறை", body: "வாழை இலை உணவு விநியோகம் முதல் ரூம் சர்வீஸ் பார்சல் பேப்பர் வரை — ஹோட்டல் அளவில் சுகாதாரமான, அழகான, மிச்சமான தீர்வு." },
    { title: "கேட்டரிங் துறை", body: "திருமணங்கள், கோவில்கள், நிறுவன நிகழ்வுகள் — இலையில் பரிமாறப்பட்டு, புதிதாக மடித்து, இறுக்கமாக மூடப்பட்டு — ஒரு நாளைக்கு ஆயிரக்கணக்கானவை." },
    { title: "உணவு பேக்கேஜிங்", body: "கிளவுட் கிச்சன்கள், ஸ்வீட் கடைகள், பேக்கரிகள் மற்றும் உணவு பதப்படுத்துபவர்களுக்கான பெட்டிகள், மூடிகள், ஃபாயில் மற்றும் ரேப்பர்கள்." },
  ],

  states: ["தமிழ்நாடு", "கேரளா", "கர்நாடகா", "மகாராஷ்டிரா", "ஆந்திர பிரதேசம்", "மத்திய பிரதேசம்"],

  buyerTypes: ["டீலர்", "விநியோகஸ்தர்", "மொத்த விற்பனையாளர்", "சில்லறை விற்பனையாளர்", "இறுதி வாடிக்கையாளர்", "சர்வதேச இறக்குமதியாளர்"],

  products: {
    "paper-banana-leaf": {
      name: "பேப்பர் வாழை இலை",
      tag: "முதன்மை தயாரிப்பு",
      desc: "பாரம்பரிய தென்னிந்திய வாழை இலை உணவு அனுபவம், உணவு தர காகிதத்தில் மறுவடிவமைப்பு. முழு சாப்பாட்டை தாங்கும் பரப்பு — சுகாதாரமான, ஒருமுறை பயன்பாடு, மிச்சம்.",
    },
    "food-wrapping-paper": {
      name: "உணவு மடிப்பு காகிதம்",
      tag: "HoReCa அத்தியாவசியம்",
      desc: "பரோட்டா, சப்பாத்தி, ஃப்ரைடு ரைஸ் மற்றும் பலவற்றுக்கு ஏற்ற ரேப்பர் — உணவை சூடாகவும் புதிதாகவும் வைக்கிறது.",
    },
    "aluminium-foil-paper": {
      name: "அலுமினியம் ஃபாயில் பேப்பர்",
      tag: "Kertas Foil",
      desc: "காகித பின்புறத்தில் லேமினேட் செய்யப்பட்ட மெல்லிய, நெகிழ்வான உணவு தர அலுமினியம் — சிறந்த வெப்ப தடுப்பு, கிழிவு எதிர்ப்பு, கசிவு தடுப்பு. எண்ணெய் உணவுகளுக்கு ஏற்றது.",
    },
    "paper-container-boxes": {
      name: "பேப்பர் கண்டெய்னர் பெட்டிகள்",
      tag: "டேக் அவே",
      desc: "கிளவுட் கிச்சன்கள், கேட்டரர்கள் மற்றும் உணவகங்களுக்கான உறுதியான, அடுக்கக்கூடிய டேக் அவே பெட்டிகள் — மொத்த விற்பனைக்கு 4 பெட்டிகள் ஒரு கட்டு.",
    },
    "paper-plates": {
      name: "பேப்பர் தட்டுகள்",
      tag: "உயிரி சிதைவு",
      desc: "ஹோட்டல்கள், திருமணங்கள், கோவில்கள் மற்றும் நிகழ்வுகளுக்கான உயிரி சிதைவு தட்டுகள் — முழு சாப்பாட்டுக்கும் உறுதியான தாங்கு.",
    },
    "aluminium-container-lids": {
      name: "அலுமினியம் கண்டெய்னர் மூடிகள்",
      tag: "சில்வர் லிட் பேப்பர்",
      desc: "அலுமினியம் கண்டெய்னர்களை இறுக்கமாக மூடும் போர்டு பின்புற சில்வர் மூடிகள் — OTG ஏற்றது, கசிவு தடுப்பு, பின்புறம் உங்கள் பிராண்டுடன் தனிப்பயனாக்கலாம்.",
    },
    "silver-parcel-paper": {
      name: "சில்வர் பார்சல் பேப்பர்",
      tag: "மொத்த விற்பனை பிடித்தது",
      desc: "ஹை-ஷைன் சில்வர் லேமினேட்டட் பார்சல் பேப்பர் — டேக் அவே துறையின் அன்றாட ரேப்பர். டீலர் நட்பு பேக்கிங்: 100 தாள்கள் × 10 பாக்கெட் ஸ்ட்ராப்.",
    },
  },

  certSubs: ["உணவு ஆராய்ச்சி சோதனை", "சர்வதேச தரம்", "உணவு தர சான்று", "சூழல் நட்பு தயாரிப்புகள்", "நிலையான வடிவமைப்பு"],

  factoryCaptions: ["இலை பாக்கெட்டுகள், கட்டி தயார்", "Lovely Leafs பெட்டி பேக்கிங்", "ஏற்றுமதி சரக்குகள் — JJJ Industries", "சில்லறை பேக்குகள், சந்தைக்குத் தயார்"],

  specLabels: {
    Sizes: "அளவுகள்",
    Material: "பொருள்",
    Thickness: "தடிமன்",
    Packing: "பேக்கிங்",
    "Shelf Life": "சேமிப்பு காலம்",
    Customization: "தனிப்பயனாக்கம்",
    Applications: "பயன்பாடுகள்",
    Finish: "மெருகு",
    "Best For": "ஏற்றது",
    Capacities: "கொள்ளளவு",
    Form: "வடிவம்",
    Strength: "வலிமை",
    Certifications: "சான்றிதழ்கள்",
    Fits: "பொருந்தும்",
    Properties: "பண்புகள்",
    Backside: "பின்புறம்",
  },

  ui: {
    nav_legacy: { en: "Legacy", ta: "பாரம்பரியம்" },
    nav_products: { en: "Products", ta: "தயாரிப்புகள்" },
    nav_presence: { en: "Presence", ta: "இருப்பு" },
    nav_manufacturing: { en: "Manufacturing", ta: "உற்பத்தி" },
    nav_contact: { en: "Contact", ta: "தொடர்பு" },
    enquire_now: { en: "Enquire Now", ta: "விசாரணை" },
    since_badge: { en: "JJJ Industries · Since 2000", ta: "JJJ Industries · 2000 முதல்" },

    hero_badge: { en: "Eco Friendly Food Packaging · Est. 2000", ta: "சூழல் நட்பு உணவு பேக்கேஜிங் · நிறுவனம் 2000" },
    hero_l1: { en: "Crafting the Future", ta: "நிலையான உணவு" },
    hero_l2a: { en: "of ", ta: "" },
    hero_l2b: { en: "Sustainable", ta: "பேக்கேஜிங்" },
    hero_l3: { en: "Food Packaging.", ta: "எதிர்காலம்." },
    hero_sub: {
      en: "Lovely Foodpacks — makers of Lovely Leafs paper banana leaf — is JJJ Industries' eco packaging house from Sivakasi. Now in our 26th year, serving hotels, caterers, wholesalers and importers across 6 Indian states and 5 countries.",
      ta: "Lovely Foodpacks — Lovely Leafs பேப்பர் வாழை இலை உற்பத்தியாளர் — சிவகாசியின் JJJ Industries சூழல் நட்பு பேக்கேஜிங் நிறுவனம். 26-ஆம் ஆண்டில், 6 இந்திய மாநிலங்கள் மற்றும் 5 நாடுகளில் ஹோட்டல்கள், கேட்டரர்கள், மொத்த விற்பனையாளர்கள் மற்றும் இறக்குமதியாளர்களுக்கு சேவை.",
    },
    hero_cta1: { en: "Start an Enquiry", ta: "விசாரணை தொடங்கு" },
    hero_cta2: { en: "Explore Products", ta: "தயாரிப்புகளைப் பார்க்க" },
    scroll: { en: "Scroll", ta: "ஸ்க்ரோல்" },

    legacy_overline: { en: "Our Legacy", ta: "எங்கள் பாரம்பரியம்" },
    legacy_heading: { en: "Twenty-six years of the leaf, told in four chapters.", ta: "இலையின் இருபத்தி ஆறு ஆண்டுகள், நான்கு அத்தியாயங்களில்." },
    legacy_intro: {
      en: "From a single product in the year 2000 to a full eco food-packaging house — the story of Lovely Foodpacks is the story of the paper banana leaf itself.",
      ta: "2000-இல் ஒரே ஒரு தயாரிப்பில் இருந்து முழு சூழல் நட்பு உணவு பேக்கேஜிங் நிறுவனமாக — Lovely Foodpacks-இன் கதை, பேப்பர் வாழை இலையின் கதையே.",
    },

    products_overline: { en: "The Catalogue", ta: "தயாரிப்பு பட்டியல்" },
    products_heading: { en: "Every pack your kitchen will ever need.", ta: "உங்கள் சமையலறைக்கு தேவையான ஒவ்வொரு பேக்கும்." },
    indiamart_link: { en: "View our IndiaMART store", ta: "IndiaMART கடையைப் பார்க்க" },
    view_spec: { en: "View Spec Sheet", ta: "விவரக் குறிப்பு" },
    enquire_whatsapp: { en: "Enquire on WhatsApp", ta: "WhatsApp-இல் விசாரிக்க" },

    presence_overline: { en: "Who We Serve", ta: "யாருக்கு சேவை" },
    presence_heading_a: { en: "Built for the", ta: "" },
    presence_heading_b: { en: " trade.", ta: "துறைக்காக உருவாக்கப்பட்டது." },
    domestic: { en: "Domestic Presence", ta: "உள்நாட்டு இருப்பு" },
    export: { en: "Export Markets", ta: "ஏற்றுமதி நாடுகள்" },
    import_ready: { en: "Import Ready", ta: "இறக்குமதி தயார்" },
    export_cta: { en: "Request Export Catalogue", ta: "ஏற்றுமதி பட்டியல் கோருக" },

    mfg_overline: { en: "Manufacturing", ta: "உற்பத்தி" },
    mfg_heading: { en: "Scale & precision, made in Sivakasi.", ta: "சிவகாசியில் துல்லியமான பெரும் உற்பத்தி." },
    mfg_body: {
      en: "Our factory at Anaiyur, Sivakasi runs printing, lamination, die-cutting and packing lines tuned for bulk — 100 sheets a packet, 4 boxes a bundle, container-loads on schedule.",
      ta: "அனையூரில் உள்ள எங்கள் தொழிற்சாலை அச்சிடல், லேமினேஷன், டை-கட்டிங் மற்றும் பேக்கிங் வரிசைகளை இயக்குகிறது — ஒரு பாக்கெட்டில் 100 தாள்கள், ஒரு கட்டில் 4 பெட்டிகள், கண்டெய்னர் அளவில் சரியான நேரத்தில்.",
    },
    process_overline: { en: "The Process", ta: "உற்பத்தி முறை" },
    process_heading: { en: "From paper roll to packed leaf.", ta: "காகித ரோலில் இருந்து கட்டப்பட்ட இலை வரை." },

    cert_overline: { en: "Tested · Certified · Trusted", ta: "சோதனை · சான்று · நம்பகம்" },

    contact_overline: { en: "Contact Us", ta: "தொடர்பு கொள்ள" },
    contact_heading: { en: "Let's talk packs, pricing & pallets.", ta: "பேக்குகள், விலை & ஆர்டர்கள் பேசலாம்." },
    contact_intro: {
      en: "One message is all it takes. Chat with our sales team on WhatsApp, call the office, or write to us — we reply fast.",
      ta: "ஒரு செய்தி போதும். WhatsApp-இல் எங்கள் விற்பனை குழுவுடன் பேசுங்கள், அலுவலகத்திற்கு அழையுங்கள் அல்லது எழுதுங்கள் — விரைவில் பதிலளிப்போம்.",
    },
    wa_sales: { en: "WhatsApp Sales", ta: "WhatsApp விற்பனை" },
    office: { en: "Office", ta: "அலுவலகம்" },
    director: { en: "Director", ta: "இயக்குநர்" },
    email: { en: "Email", ta: "மின்னஞ்சல்" },
    head_office: { en: "Head Office", ta: "தலைமை அலுவலகம்" },
    factory: { en: "Factory", ta: "தொழிற்சாலை" },

    form_overline: { en: "Bulk · Wholesale · Export", ta: "மொத்தம் · சில்லறை · ஏற்றுமதி" },
    form_heading: { en: "Tell us what you need.", ta: "உங்களுக்கு என்ன தேவை என்று சொல்லுங்கள்." },
    form_intro: {
      en: "Fill this in — it opens a ready-to-send WhatsApp chat with our sales team.",
      ta: "இதை நிரப்புங்கள் — எங்கள் விற்பனை குழுவுடன் தயாரான WhatsApp உரையாடலைத் திறக்கும்.",
    },
    form_buyer: { en: "I am a *", ta: "நான் ஒரு *" },
    form_buyer_ph: { en: "Select buyer type", ta: "வாங்குபவர் வகையைத் தேர்ந்தெடுக்கவும்" },
    form_name: { en: "Your Name *", ta: "உங்கள் பெயர் *" },
    form_name_ph: { en: "Full name", ta: "முழு பெயர்" },
    form_business: { en: "Business Name", ta: "வணிகப் பெயர்" },
    form_business_ph: { en: "Hotel / Store / Company", ta: "ஹோட்டல் / கடை / நிறுவனம்" },
    form_whatsapp: { en: "Your WhatsApp Number *", ta: "உங்கள் WhatsApp எண் *" },
    form_location: { en: "Location / City", ta: "இருப்பிடம் / நகரம்" },
    form_location_ph: { en: "City, State / Country", ta: "நகரம், மாநிலம் / நாடு" },
    form_detect: { en: "Detect", ta: "கண்டறி" },
    form_locating: { en: "Locating", ta: "கண்டறிகிறது" },
    form_product: { en: "Product Interest", ta: "தயாரிப்பு விருப்பம்" },
    form_product_ph: { en: "Select a product (optional)", ta: "தயாரிப்பைத் தேர்ந்தெடுக்கவும் (விருப்பம்)" },
    form_message: { en: "Message", ta: "செய்தி" },
    form_message_ph: { en: "Quantity, sizes, delivery city / port...", ta: "அளவு, சைஸ், டெலிவரி நகரம் / துறைமுகம்..." },
    form_send: { en: "Send via WhatsApp", ta: "WhatsApp மூலம் அனுப்பு" },
    form_email: { en: "Or Email Us", ta: "அல்லது மின்னஞ்சல்" },
    full_catalogue: { en: "Complete Catalogue", ta: "முழு பட்டியல்" },

    footer_explore: { en: "Explore", ta: "ஆராய" },
    footer_reach: { en: "Reach Us", ta: "தொடர்பு" },
    footer_tagline: { en: "Traditional Service in Economy way", ta: "பொருத்தமான விலையில் பாரம்பரிய சேவை" },
    footer_about: {
      en: "Lovely Foodpacks — home of Lovely Leafs paper banana leaf. A JJJ Industries company, manufacturing eco-friendly food packaging in Sivakasi since 2000.",
      ta: "Lovely Foodpacks — Lovely Leafs பேப்பர் வாழை இலையின் இல்லம். JJJ Industries நிறுவனம், 2000 முதல் சிவகாசியில் சூழல் நட்பு உணவு பேக்கேஜிங் உற்பத்தி.",
    },
    footer_rights: { en: "All rights reserved.", ta: "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை." },
    footer_products_line: {
      en: "Paper Banana Leaf · Food Wrapping Paper · Foil Paper · Container Boxes · Plates · Lids",
      ta: "பேப்பர் வாழை இலை · உணவு மடிப்பு காகிதம் · ஃபாயில் பேப்பர் · கண்டெய்னர் பெட்டிகள் · தட்டுகள் · மூடிகள்",
    },

    float_chat: { en: "Chat with Sales", ta: "விற்பனையுடன் அரட்டை" },

    back_catalogue: { en: "Back to Catalogue", ta: "பட்டியலுக்குத் திரும்ப" },
    spec_sheet: { en: "Specification Sheet", ta: "விவரக் குறிப்பு" },
    wholesale_pricing: { en: "Get Wholesale Pricing", ta: "மொத்த விலை கேட்க" },
    view_indiamart: { en: "View on IndiaMART", ta: "IndiaMART-இல் பார்க்க" },
    also_catalogue: { en: "Also in the Catalogue", ta: "மற்ற தயாரிப்புகள்" },
    also_searched: { en: "Also searched as", ta: "வேறு பெயர்களில் தேடப்படுகிறது" },
    spec_note: {
      en: "Specifications are indicative of our standard production range — exact sizes, GSM and packing are confirmed on enquiry. Custom runs available for wholesale & export orders.",
      ta: "விவரக் குறிப்புகள் எங்கள் நிலையான உற்பத்தி வரம்பின் சுட்டிக்காட்டு — சரியான அளவுகள், GSM மற்றும் பேக்கிங் விசாரணையில் உறுதி செய்யப்படும். மொத்த & ஏற்றுமதி ஆர்டர்களுக்கு தனிப்பயன் உற்பத்தி உண்டு.",
    },
  },
};

export const u = (lang, key) => TA.ui[key]?.[lang] ?? TA.ui[key]?.en ?? key;
